import IconServiceElevatorIntegration from './IconServiceElevatorIntegration';

export default IconServiceElevatorIntegration;
